module.exports = __webpack_public_path__ + "static/main-img-how-we-work-eac2795716f0c1a696bb2671331f54c9.png";